import { RoundIntegrityWatcher, RoundIntegrityWatcherPhases } from '../../../logger/RoundIntegrityWatcher';
import type { GameCommunicationMetaType, GameCommunicationSenderType } from '../../../services/gameCommunication/types';
import { SOCKET_CONNECTION_STATUS } from '../../../services/webSocket/types';
import { CoreStoreType } from '../../../store/CoreStore';
import { gameStateActions } from '../../../store/slices/game/slice';
import { GameStatus } from '../../../store/slices/game/types';
import type { GameCommunicationMessageType } from '../types';
import { MessageName } from '../types';

import { BaseCoreGameCommunicationProcessor } from './BaseCoreGameCommunicationProcessor';

export interface TimerMessage extends GameCommunicationMessageType {
  value: string;
}

export class CoreTimerGameCommunicationProcessor extends BaseCoreGameCommunicationProcessor {
  public messageName = MessageName.Timer;

  public process(
    message: TimerMessage,
    _store: CoreStoreType,
    _sender: GameCommunicationSenderType,
    { connectionStatus, connectionProcedure }: GameCommunicationMetaType
  ): void {
    const state = this.store.getState();

    RoundIntegrityWatcher.setPhase(RoundIntegrityWatcherPhases.Timer);

    const value = Number(message.value) - message.meta.delay / 1000;
    const bettingLastCall = state.config.timings?.bettingLastCall || 0;
    const lastCallSeconds = bettingLastCall / 1000;

    const fromReconnect =
      connectionStatus === SOCKET_CONNECTION_STATUS.RECONNECTING ||
      connectionStatus === SOCKET_CONNECTION_STATUS.RECONNECTED;

    // On timer message set isLoadedInActiveRound flag if timer is less than zero, and it is initial websocket connection
    this.store.dispatch(gameStateActions.setIsLoadedInActiveRound(value <= 0 && !fromReconnect));
    this.store.dispatch(gameStateActions.setTimer(value));

    connectionProcedure();

    if (fromReconnect && value <= 0) {
      this.store.dispatch(gameStateActions.resetCurrentGameStatus());
      return;
    }
    if (value > lastCallSeconds) {
      this.store.dispatch(gameStateActions.setCurrentGameStatus(GameStatus.PlaceYourBets));
      return;
    }
    if (value > 0) {
      if (state.gameState.currentStatus !== GameStatus.BetsClosed) {
        this.store.dispatch(gameStateActions.setCurrentGameStatus(GameStatus.LastBets));
      }
    }
  }
}
